import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import { Page as HomePage } from '@/modules/HomePage/index'
import getPageLangGlossary from '../utils/getPageLangGlossary'
import type { Glossary, Category } from '@/types/glossary'
import { useTranslation } from 'react-i18next'
import { glossaryLanguages } from '@/i18n/config'
import { useCookies } from 'react-cookie'
import { getBrowserPrefLang } from '../utils'
import { getLocalePath } from '../utils'

const Index = (props: any) => {
  const { allGlossary, lang, categoriesMap } = props.pageContext
  const [cookies, setCookie] = useCookies(['locale'])
  const { i18n } = useTranslation()

  const allGlossaryInPageLang = getPageLangGlossary(allGlossary, lang)

  const TrendingGlossary: Glossary[] = []
  allGlossaryInPageLang.forEach((x: Glossary) => {
    x.categories.forEach((cat: string) => {
      if (categoriesMap[cat]?.slug === 'trending-glossary-en') {
        TrendingGlossary.push(x)
        return
      }
    })
  })

  useEffect(() => {
    let preferedLang = cookies['locale']
    const path = getLocalePath(location.pathname)
    const allAvaLangs = glossaryLanguages.map((lang) => lang.code)
    const browserLang = getBrowserPrefLang(allAvaLangs)
    if (path === 'en') {
      if (
        preferedLang &&
        (preferedLang !== 'en' || preferedLang !== 'en-US') &&
        allAvaLangs.includes(preferedLang)
      ) {
        const path = glossaryLanguages.find(
          (item) => item.code === preferedLang
        )?.path
        navigate(`/glossary${path}`)
      } else if (
        browserLang &&
        !['en', 'en-US'].includes(browserLang) &&
        allAvaLangs.includes(browserLang)
      ) {
        const path = glossaryLanguages.find(
          (item) => item.code === browserLang
        )?.path
        navigate(`/glossary${path}`)
      }
    }
  }, [cookies])

  return (
    <>
      <HomePage
        allGlossary={allGlossaryInPageLang}
        TrendingGlossary={TrendingGlossary.slice(0, 10)}
      />
    </>
  )
}

export default Index

export const Head = () => {
  const seo = {
    title:
      'Crypto.com Glossary: Your Guide to Key Terms and Jargon in Blockchain and Cryptocurrency',
    description:
      "Check Crypto.com's crypto glossary to learn what commonly used terms used in the crypto-verse mean.",
    image: 'https://crypto.com/images/meta-og/listing.png',
    url: 'https://crypto.com/glossary',
    creator: 'Crypto.com',
  }
  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.creator} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={seo.description} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <link rel="canonical" href="https://www.crypto.com/glossary" />
    </>
  )
}
